(function () {
    'use strict';

    angular.module('jotApp')
        .directive('objectFilter', dashboardFilter);

    function dashboardFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                fleetVal: '&',
                objectStateVal: '&',
                objectTypeVal: '&',
                networkVal: '&',
                releaseVal: '&',
                monitorVal: '&'
            },
            template: '<div class="row">\n' +
            '    <div class="col-xs-12">\n' +
            '        <div class="portlet light filter-portlet bordered">\n' +
            '            <div class="portlet-body form">\n' +
            '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
            '                    <div class="form-body">\n' +
            '                        <div class="row">\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label class="control-label ng-scope" for="fleet_field">Fleet</label>\n' +
            '                                    <ui-select ng-model="vm.fleet" theme="bootstrap" id="fleet_field" on-select="vm.onFleetSelect($item)">\n' +
            '                                        <ui-select-match placeholder="Select or search a fleet..">\n' +
            '                                            {{$select.selected.fleetName}}\n' +
            '                                        </ui-select-match>\n' +
            '                                        <ui-select-choices repeat="item in vm.fleets | propsFilter: {fleetName: $select.search, fleetDescription: $select.search}">\n' +
            '                                            <div ng-bind-html="item.fleetName | highlight: $select.search"></div>\n' +
            '                                            <small ng-bind-html="item.fleetDescription | highlight: $select.search"></small>\n' +
            '                                        </ui-select-choices>\n' +
            '                                    </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label class="control-label ng-scope" for="objectType_field">Object Type</label>\n' +
            '                                    <ui-select ng-model="vm.objectType" id="objectType_field" theme="bootstrap">\n' +
            '                                        <ui-select-match\n' +
            '                                            placeholder="Select or search an object type...">\n' +
            '                                            {{$select.selected.objectTypeName}}\n' +
            '                                        </ui-select-match>\n' +
            '                                        <ui-select-choices repeat="item in vm.objectTypes | filter: {objectTypeName: $select.search}">\n' +
            '                                            <div ng-bind-html="item.objectTypeName | highlight: $select.search"></div>\n' +
            '                                        </ui-select-choices>\n' +
            '                                    </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-2 inline-filter-button">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label class="control-label ng-scope" for="submit_field"></label>\n' +
            '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
            '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
            '                                    </button>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                        </div>\n' +
            '                        <div class="row">\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_state">States</label>\n' +
            '                                    <select class="form-control" id="field_state" required name="states" ng-model="vm.objectState"\n chosen disable-search="true"' +
            '                                            ng-options="objectState as (objectState.objectStateName | uppercase) for objectState in vm.objectStates track by objectState.id "></select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-5">\n' +
            '                                   <div class="form-group">\n' +
            '                                       <label for="field_release">Release Status</label>\n' +
            '                                       <select class="form-control" id="field_release"  name="release" ng-model="vm.release"\n chosen disable-search="true"' +
            '                                            ng-options="release as (release.value | uppercase) for release in vm.updateFilter track by release.id"></select>\n' +
            '                                   </div>\n' +
            '                            </div>\n' +
            '                        </div>\n' +
            '                       <div class="row">\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_network">Network Status</label>\n' +
            '                                    <select class="form-control" id="field_network" required name="network" ng-model="vm.network"\n chosen disable-search="true"' +
            '                                            ng-options="network as (network.value | uppercase) for network in vm.onlineFilter track by network.id "></select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-5">\n' +
            '                                   <div class="form-group">\n' +
            '                                       <label for="field_monitor">Monitoring status</label>\n' +
            '                                       <select class="form-control" id="field_monitor"  name="monitor" ng-model="vm.monitor"\n chosen disable-search="true"' +
            '                                            ng-options="monitor as (monitor.value | uppercase) for monitor in vm.trackedFilter track by monitor.id"></select>\n' +
            '                                   </div>\n' +
            '                            </div>\n' +
            '                        </div>\n' +
            '                    </div>\n' +
            '                </form>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>\n',
            controller: ObjectFilterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    ObjectFilterController.$inject = ['TabFleets', 'TabObjectTypes', 'TabObjectStates'];

    function ObjectFilterController(TabFleets, TabObjectTypes, TabObjectStates) {
        var vm = this;
        vm.fleets = TabFleets.query({
            page: 0,
            size: 100
        });
        vm.fleets.$promise.then(function (data) {
            data.unshift(allFleet);
        });

        TabObjectTypes.mapped().$promise.then(function (data) {
            mappedObjectType = JSON.parse(angular.toJson(data));
            mapObjectTypes();
            vm.objectTypes = mappedObjectType[vm.fleet.id];
        });

        var allFleet = {
            id: -1,
            fleetName: "All"
        };
        var allStates = {
            id: -1,
            objectStateName: "All"
        };
        var allObjectType = {
            id: -1,
            objectTypeName: "All"
        };
        var mappedObjectType = {};
        vm.onlineFilter = [{id: -1, value: 'ALL'}, {id: 1, value: 'ONLINE', query: true}, {
            id: 2,
            value: 'OFFLINE',
            query: false
        }];
        vm.updateFilter = [{id: -1, value: 'ALL'}, {id: 1, value: 'TO UPDATE', query: true}, {
            id: 2,
            value: 'UPDATED',
            query: false
        }];
        vm.trackedFilter = [{id: -1, value: 'ALL'}, {id: 1, value: 'TRACKED', query: true}, {
            id: 2,
            value: 'UNTRACKED',
            query: false
        }];
        vm.network = +vm.networkVal() === -1 || +vm.networkVal().id === -1 ? vm.onlineFilter[0] : vm.onlineFilter[+vm.networkVal().id];
        vm.release = +vm.releaseVal() === -1 || +vm.releaseVal().id === -1 ? vm.updateFilter[0] : vm.updateFilter[+vm.releaseVal().id];
        vm.monitor = +vm.monitorVal() === -1 || +vm.monitorVal().id === -1 ? vm.trackedFilter[0] : vm.trackedFilter[+vm.monitorVal().id];
        vm.objectState = +vm.objectStateVal() === -1 || +vm.objectStateVal().id === -1 ? allStates : vm.objectStateVal();
        vm.fleet = +vm.fleetVal() === -1 || +vm.fleetVal().id === -1 ? allFleet : vm.fleetVal();
        vm.objectType = +vm.objectTypeVal() === -1 || +vm.objectTypeVal().id === -1 ? allObjectType : vm.objectTypeVal();
        vm.objectTypes = [];

        vm.objectStates = TabObjectStates.query();
        vm.objectStates.$promise.then(function (data) {
            data.unshift(allStates);
        });


        vm.onFleetSelect = function (fleet) {
            vm.objectTypes = mappedObjectType[fleet.id];
            vm.objectType = {};
            if (vm.objectTypes.length > 0) {
                vm.objectType = allObjectType;
            }
        };

        vm.submit = function () {
            vm.filter({
                fleet: vm.fleet,
                objectType: vm.objectType,
                state: vm.objectState,
                update: vm.release,
                online: vm.network,
                tracked: vm.monitor
            });
        };

        function mapObjectTypes() {
            for (var fleet in mappedObjectType) {
                if (mappedObjectType[fleet].length > 0) {
                    mappedObjectType[fleet].unshift(allObjectType);
                }
            }

        }

    }
})();

